import React, { PureComponent } from 'react';

import SVGIcon, { BASE_ICONS } from 'src/components/svg';

import { lang, remCss, rgba, scssVariables as variables } from 'src/helpers';
import { MCButton } from './MCButton';
import LANG_CONST from 'src/helpers/lang/const';

export default class SearchTextField extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value || '',
      prevValue: props.value || '',
      isFocus: false
    };
    this.inputRef = React.createRef();
  }

  static getDerivedStateFromProps(prop, state) {
    if (prop.value !== undefined && prop.value !== state.prevValue) {
      return {
        value: prop.value || '',
        prevValue: prop.value || ''
      };
    }
    return null;
  }

  changeInput = (event) => {
    const self = this;
    const value = event ? event.target.value : '';

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      value,
      typingTimeout: setTimeout(
        function () {
          const { onChange } = self.props;
          if (onChange) {
            onChange(value);
          }
        },
        value === '' ? 0 : 500
      )
    });
  };

  iconClose = () => {
    return (
      <MCButton
        text
        iconname={BASE_ICONS.CLOSE}
        width={20}
        type={'button'}
        onClick={() => {
          this.changeInput(null);
          if (this.props.onKeyDown) {
            this.props.onKeyDown(null);
          }

          if (this.props.hideSearchFn) {
            this.props.hideSearchFn();
          }
        }}
        style={{ height: remCss(20), marginRight: remCss(15) }}
      />
    );
  };

  render() {
    const {
      placeholder,
      classContainer = '',
      template = '1',
      inputTestId,
      width = '100%',
      style = {}
    } = this.props;

    const w = !isNaN(parseFloat(width)) && isFinite(width) ? remCss(width) : width;
    return (
      <div
        className={`mc-search-text mc-flex template-${template} ` + classContainer}
        style={{ maxWidth: w, width: w, ...style }}
      >
        {!this.props.hideSearchFn && (
          <div
            className={'mc-placeholder-icon'}
            onClick={() => {
              this.inputRef.current.focus();
            }}
          >
            <SVGIcon
              iconname={BASE_ICONS.SEARCH}
              strokeWidthIcon={0.5}
              fill={rgba(variables['colors-mc-primary'], 0.6)}
              width={30}
            />
          </div>
        )}
        <input
          type='text'
          ref={this.inputRef}
          data-testid={inputTestId}
          style={{ minWidth: 1 }}
          className='mc-search-text-input mc-grow'
          value={this.state.value}
          onChange={this.changeInput}
          placeholder={lang.t(placeholder || LANG_CONST.text.search)}
          onFocus={() => {
            this.setState({ isFocus: true });
            if (this.props.onFocus) {
              this.props.onFocus();
            }
          }}
          autoFocus={this.props.autoFocus}
          onKeyDown={this.props.onKeyDown}
          onBlur={() => {
            this.setState({ isFocus: false });
            if (this.props.onBlur) {
              this.props.onBlur();
            }
          }}
        />
        {(this.state.value || this.props.hideSearchFn) && this.iconClose()}
      </div>
    );
  }
}
